import type { ReactNode } from 'react';
import { Check } from 'lucide-react';
import clsx from 'clsx';

interface CheckboxProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  children: ReactNode;
  error?: string | null;
  disabled?: boolean;
}

// Квадратный кастомный чекбокс: ink-заливка при активном состоянии.
// Ссылки внутри label, ink underline, чтобы соответствовали стилю лендинга.
export default function Checkbox({ checked, onChange, children, error, disabled }: CheckboxProps) {
  return (
    <label
      className={clsx(
        'flex items-start gap-3 cursor-pointer select-none',
        disabled && 'cursor-not-allowed opacity-60',
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="sr-only"
      />
      <span
        className={clsx(
          'mt-0.5 grid h-[18px] w-[18px] shrink-0 place-items-center border transition-colors',
          checked
            ? 'bg-ink border-ink text-white'
            : error
              ? 'border-orange bg-white'
              : 'border-ink/30 bg-white hover:border-ink',
        )}
      >
        {checked && <Check size={12} strokeWidth={2.5} />}
      </span>
      <span className="text-[13px] leading-snug text-ink/80">{children}</span>
    </label>
  );
}
